import React, { useState } from "react";

import {
  RideButton,
  RideGlArrowForward,
  RideGlInformationOutline,
} from "@rimac-seguros/ride-system-components";
import helpers from "@/utils/helpers";
import { useSelector } from "react-redux";

import { ModalRightOfWithdrawal } from "../ModalRightOfWithdrawal";

export const CardConditions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { userData } = useSelector((state) => state.vida);
  const isEmbedded = userData.indPrevPageApp;

  const handleModal = () => {
    if (isEmbedded) {
      helpers.sendMessageToApp("EMBEDDED-APP-HIDE-TOPBAR");
    }
    helpers.getTagAction(
      "Seguro Vida Devolución Garantizada",
      "Resumen y pago",
      "click",
      "Ver condiciones",
      "trackAction"
    );
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    if (isEmbedded) {
      helpers.sendMessageToApp("EMBEDDED-APP-SHOW-TOPBAR");
    }
    setIsOpen(false);
  };

  return (
    <>
      <div
        className={`
        flex w-full
        gap-ride-gl-spacing-medium
        mt-ride-gl-spacing-4xlarge
        p-ride-gl-spacing-3xlarge
        pb-ride-gl-spacing-large
        rounded-ride-sys-border-radius-container-large
        border-ride-gl-border-width-medium
        border-ride-sys-color-border-default
        lg:mt-ride-gl-spacing-6xlarge
      `}
      >
        <RideGlInformationOutline size="large" />
        <div className="flex flex-col">
          <p className="ride-sys-text-paragraph-small-default">
            Conoce sobre tus beneficiarios, solicitud a la desafiliación del
            débito automático y acerca del derecho de arrepentimiento.
          </p>
          <RideButton
            text="Ver condiciones"
            variant="text-primary"
            glyph={<RideGlArrowForward />}
            size="medium"
            className="w-max"
            onClick={handleModal}
          />
        </div>
      </div>
      {isOpen && (
        <ModalRightOfWithdrawal isOpen={isOpen} onClose={handleCloseModal} />
      )}
    </>
  );
};
